module.exports = __webpack_public_path__ + "media/images/test-banner-b6256eb6c0c36716a4a900d989fb215c.jpg";